import React, { useEffect, useRef } from "react";
import authService from "../../service/authService";
import { useNavigate } from "react-router-dom";

interface InactivityTimeoutProps {
  children: React.ReactNode;
}

const InactivityTimeout: React.FC<InactivityTimeoutProps> = ({ children }) => {
  const timeoutId = useRef<NodeJS.Timeout | null>(null);
  const navigate = useNavigate();
  const INACTIVITY_LIMIT = 30 * 60 * 1000;

  const resetTimeout = () => {
    const expiryTime = new Date().getTime() + INACTIVITY_LIMIT;
    localStorage.setItem("inactivityExpiry", expiryTime.toString());

    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      const expiry = localStorage.getItem("inactivityExpiry");
      if (expiry && new Date().getTime() > parseInt(expiry, 10)) {
        authService.logout();
        navigate("/login");
      }
    }, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    const events = ["mousemove", "keypress", "scroll"];

    const handleEvent = () => {
      resetTimeout();
    };

    events.forEach((event) => {
      window.addEventListener(event, handleEvent);
    });

    const expiry = localStorage.getItem("inactivityExpiry");
    if (expiry && new Date().getTime() > parseInt(expiry, 10)) {
      authService.logout();
      navigate("/login");
    } else {
      resetTimeout();
    }

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleEvent);
      });
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, [navigate]);

  return <>{children}</>;
};

export default InactivityTimeout;
